import SolutionCard from "../../reusables/SolutionCard";
import social from "../../../assets/images/solutions-icon/social-media-manager.svg";

const SMmanagementSolution = () => {
  return (
    <SolutionCard
      icon={social}
      title="Social Media Management & Growth"
      subtitle="Professional setup, management and growth of your social media accounts"
      ctaLink="/solutions/social-media-management"
    />
  );
};
 
export default SMmanagementSolution;